import { Action } from '@ngrx/store';
import {
  TechnicalError,
  WifiInformationModel,
} from '@dch/products-business-logic';

export const GET_WIFI_INFORMATION = 'GET_WIFI_INFORMATION';
export const GET_WIFI_INFORMATION_SUCCESS = 'GET_WIFI_INFORMATION_SUCCESS';
export const GET_WIFI_INFORMATION_FAILED = 'GET_WIFI_INFORMATION_FAILED';

export class GetWifiInformation implements Action {
  type = GET_WIFI_INFORMATION;

  constructor(public payload?: any) {}
}

export class GetWifiInformationSuccess implements Action {
  type = GET_WIFI_INFORMATION_SUCCESS;

  constructor(public payload: WifiInformationModel) {}
}

export class GetWifiInformationFailed implements Action {
  type = GET_WIFI_INFORMATION_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetWifiInformation
  | GetWifiInformationSuccess
  | GetWifiInformationFailed;
